module.exports = __webpack_public_path__ + "static/img/1.4e63707.png";


//////////////////
// WEBPACK FOOTER
// ./static/images/products/6/1/12/sp/1.png
// module id = MCOb
// module chunks = 0